export function isValidPhone(number, minLength) {
    const regex = new RegExp(`^\\d{${minLength},}$`);
    return regex.test(number);
}

export function isValidEmail(email) {
    const regex = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
    return regex.test(email);
}